module.exports = __webpack_public_path__ + "static/google-product-categories-explained-925b988da8a6973bc9a4f01086f787e9.jpg";